import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import Global from '../../../store/global-selectors';

const name = <FormattedMessage {...messages.categoryIdColumnHeader} />;

const ProductCategory = ({ categoryId }) => {
  const productCategoryName = useSelector((state) =>
    Global.selectEntitiesProductCategoryPropertyById(state, {
      categoryId,
      property: 'name',
    }),
  );

  return productCategoryName || '';
};

export default {
  getMessageDescriptor: () => messages.categoryIdColumnHeader,
  name,
  render: (data) => <ProductCategory categoryId={data.categoryId} />,
};
